<template>
  <div
    class="country-card card-condition condition__ip-blacklisted"
    :class="{
      noteq: value === 'IS_NOT_IP_BLACKLISTED',
      'card-condition__planLimits': hasPlanLimitsRestriction('ivtIpIsBlacklisted'),
    }"
  >
    <ui-tooltip-icon
      v-if="hasPlanLimitsRestriction('ivtIpIsBlacklisted')"
      class="card-condition__planLimits--tooltip"
      preset="error"
      :text="t('This option is no longer active due to the subscription change to the plan which doesn’t include this option or this add-on is switched off in your subscriptions settings.')"
    ></ui-tooltip-icon>
    <ui-icon @click="emit('close')" size="12" icon="fas fa-times" class="card-condition__close" />
    <ui-radio-group style-type="inline" v-model="value" :label="t('Suspicious Traffic (blacklisted IPs)')">
      <div class="d-flex align-baseline ml-16">
        <ui-radio value="IS_IP_BLACKLISTED" :label="t('IPs From Blacklists')" />
        <ui-radio class="ml-16" value="IS_NOT_IP_BLACKLISTED" :label="t('IPs Not From Blacklists')" />
      </div>
    </ui-radio-group>
  </div>
</template>

<script setup lang="ts">
import { useFlowSingleValueCondition } from './useFlowSingleValueCondition';

const props = defineProps<{
  conditions: Record<string, { predicate: string; values: string }>;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { t, value, hasPlanLimitsRestriction } = useFlowSingleValueCondition(props.conditions, {
  conditionKey: 'ipBlacklisted',
  defaultValue: 'IS_NOT_IP_BLACKLISTED',
  planLimitsKey: 'ivtIpIsBlacklisted',
});
</script>
